import { apiCall } from "../service/api-service";

export const createOrderApi = async (data) => {
  return apiCall("POST", "order", data);
};

export const updateOrderApi = async (data, id) => {
  return apiCall("PUT", `order/${id}`, data);
};

export const updateOrderStatusApi = async (data, id) => {
  return apiCall("PUT", `order/update_status/${id}`, data);
};

export const getOrderDetailsApi = async (id) => {
  return apiCall("GET", `order/edit/${id}`);
};
export const getOrderViewDetailsApi = async (id) => {
  return apiCall("GET", `order/view/${id}`);
};

export const getOrgCurrencyApi = async () => {
  return apiCall("GET", "get_order_org_currency");
};

// Get all orders (list)
export const getOrdersListApi = async (params = {}) => {
  return apiCall("GET", `order${params}`);
};

export const bulkDeleteOrdersApi = async (ids) => {
  const data = Array.isArray(ids) ? { ids } : ids;
  return apiCall("DELETE", "order/bulk_delete", data);
};

export const getHistoryApi = async (id) => {
  return apiCall("GET", `order/history/${id}`);
};

export const getWorkflowApi = async (id) => {
  return apiCall("GET", `order/workflow/${id}`);
};

export const getOrderInvoicesApi = async (id, params = "") => {
  return apiCall("GET", `order/get_invoices/${id}${params}`);
};

export const getStateTaxApi = async (id) => {
  return apiCall("POST", "check_state_tax", { state_id: id });
};

// Customer Details APIs
export const getCustomerDetailsApi = async (id) => {
  return apiCall("GET", `get_customer_details/${id}`);
};

export const getLeadDetailsApi = async (id) => {
  return apiCall("GET", `get_lead_details/${id}`);
};

// Attachment APIs
export const addOrderAttachmentApi = async (orderId, attachmentData) => {
  return apiCall("POST", `order/add_attachment/${orderId}`, attachmentData);
};

export const addOrderAttachmentsBulkApi = async (orderId, attachmentArray) => {
  // Send multiple attachments in single API call for better performance
  return apiCall("POST", `order/add_attachment/${orderId}`, {
    attachments: attachmentArray,
  });
};

export const getOrderAttachmentsApi = async (orderId) => {
  return apiCall("GET", `order/attachment/${orderId}`);
};

export const removeOrderAttachmentApi = async (attachmentId) => {
  return apiCall("DELETE", `order/remove_attachment/${attachmentId}`);
}

export const askOrderChatApi = async (payload) => {
  return apiCall("POST", "order/ai_chat", payload);
};

export const getOrderAiProvidersApi = async () => {
  return apiCall("GET", "order/ai_providers");
};
